"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var term_service_1 = require("./services/term.service");
var term_component_1 = require("./components/term.component");
var common_module_1 = require("../common/common.module");
var core_1 = require("@angular/core");
var core_2 = require("@ngx-translate/core");
var TermModule = (function () {
    function TermModule() {
    }
    return TermModule;
}());
TermModule = __decorate([
    core_1.NgModule({
        imports: [
            core_2.TranslateModule,
            common_module_1.TRTCommonModule
        ],
        exports: [term_component_1.TermComponent],
        declarations: [term_component_1.TermComponent],
        providers: [term_service_1.TermService],
    })
], TermModule);
exports.TermModule = TermModule;
